import { render, staticRenderFns } from "./Loginget.vue?vue&type=template&id=8bc89632&"
import script from "./Loginget.vue?vue&type=script&lang=js&"
export * from "./Loginget.vue?vue&type=script&lang=js&"
import style0 from "./Loginget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports